<div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-4">
    <div class="card stat-card">
        <div class="stat-label">Gefahrene Rennen</div>
        <div class="stat-value">{{ numberOfRaces }}</div>
        <i class="pi pi-flag stat-icon"></i>
    </div>
    <div class="card stat-card">
        <div class="stat-label">Beste Platzierung</div>
        <div class="stat-value">{{ bestPlacement ? 'P' + bestPlacement : '–' }}</div>
        @if (bestPlacementCircuit) {
            <div class="stat-sub">{{ bestPlacementCircuit }}</div>
        }
        <i class="pi pi-trophy stat-icon"></i>
    </div>
    <div class="card stat-card">
        <div class="stat-label">Ligafahrer seit</div>
        <div class="stat-value text-2xl">{{ (firstRaceDate | date: 'dd.MM.yyyy') || '–' }}</div>
        <i class="pi pi-calendar stat-icon"></i>
    </div>
    <div class="card stat-card">
        <div class="stat-label">Vorfälle</div>
        <div class="stat-value">{{ numberOfIncidents }}</div>
        <i class="pi pi-exclamation-circle stat-icon"></i>
    </div>
</div>
